export default __webpack_public_path__ + "static/media/icon_text size.4c267ef5.svg";